import { render } from "./RefundView.vue?vue&type=template&id=fb1c4a8e&scoped=true&lang=pug"
import script from "./RefundView.vue?vue&type=script&lang=js"
export * from "./RefundView.vue?vue&type=script&lang=js"

import "./RefundView.scss?vue&type=style&index=0&id=fb1c4a8e&scoped=true&lang=scss"

import exportComponent from "/builds/wiwdata/applications/finance-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb1c4a8e"]])

export default __exports__